import styled from 'styled-components';

import {
  Input as SemanticInput,
  Grid as SemanticGrid,
} from 'semantic-ui-react';

import {
  Button as ButtonLayoutComponent,
  Loader as LoaderLayoutComponent, Text as TextLayoutComponent,
} from '@playbookux/playbook-web-core';

const Container = styled.div`
  margin-top: 5px;
  padding: 0px 10px;
  width: 100%;
`;

const ContainerGenerateLink = styled.div`
  align-items: center;
  display: flex;
  margin-bottom: 10px;
`;

const Button = styled(ButtonLayoutComponent)`
  &.ui.button {
    width: 200px;
  }
`;

const ExportButton = styled(ButtonLayoutComponent)`
  &.ui.button {
    width: 200px;
    margin-bottom: 30px;
  }
`;

const CreateSuccess = styled(TextLayoutComponent)`
  margin-left: 20px;
`;

const CreateError = styled(TextLayoutComponent.Error)`
  margin-left: 20px;
`;

const Input = styled(SemanticInput)`
  width: 50%;
`;

const Grid = styled(SemanticGrid)`
  &&& {
    margin: 0px;
  }
`;

const Row = styled(SemanticGrid.Row)`
`;

const HeaderRow = styled(SemanticGrid.Row)`
  &&& {
    padding: 0px;
  }
`;

const Column = styled(SemanticGrid.Column)`
`;

const Header = styled(TextLayoutComponent.Bold)`
`;

const Data = styled(TextLayoutComponent)`
`;

const NoDataMessage = styled(TextLayoutComponent)`
  margin-top: 20px;
`;

const LoadMore = styled.a`
  cursor: pointer;
`;

const LoadMoreContainer = styled.div`
  margin-top: 20px;
`;

const Loader = styled(LoaderLayoutComponent)`
`;

const ErrorMessage = styled(TextLayoutComponent)`
`;

const Link = styled.a`
  margin-left: 20px;
`;

const SegmentName = styled.p`
  font-weight: bold;
  display: block;
  margin-top: 16px;
`;

const UserInterviewsLink = styled(TextLayoutComponent)`
  color: ${(props) => props.theme.color.secondary};
`;

export {
  Button,
  ExportButton,
  Column,
  Container,
  ContainerGenerateLink,
  CreateError,
  CreateSuccess,
  Data,
  ErrorMessage,
  Grid,
  Header,
  HeaderRow,
  Input,
  Link,
  Loader,
  LoadMore,
  LoadMoreContainer,
  NoDataMessage,
  Row,
  SegmentName,
  UserInterviewsLink,
};
